import { render } from "./ModalNotificationOutStockItems.vue?vue&type=template&id=587360b2&scoped=true"
import script from "./ModalNotificationOutStockItems.vue?vue&type=script&lang=js"
export * from "./ModalNotificationOutStockItems.vue?vue&type=script&lang=js"

import "./ModalNotificationOutStockItems.vue?vue&type=style&index=0&id=587360b2&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587360b2"]])

export default __exports__